import appStore from 'store';
import api from './api';
import { NOTICE_TYPE } from './constants';
import { PAGINATION } from 'common/config';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    noticeTypes: NOTICE_TYPE,
    noticeList: [],
    totalCount: 0,
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: Number(item),
        label: LANGUAGE[item]
      };
    }),
    pagination: PAGINATION,
    noticeDetail: {
      title: {},
      content: {}
    },
    noticeDetailDialogVisible: false
  },
  mutations: {
    setNoticeList(state, payload) {
      state.noticeList = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setNoticeTotalCount(state, payload) {
      state.totalCount = payload;
    },
    setNoticeDetail(state, payload) {
      state.noticeDetail = payload;
    },
    setNoticeDetailDialogVisible(state, payload) {
      state.noticeDetailDialogVisible = payload;
    }
  },
  getters: {},
  actions: {
    list({ commit }, query) {
      commit('setPagination', { page: query.page, size: query.size });

      api.getNoticeList(query).then(({ data }) => {
        commit('setNoticeList', data.list);
        commit('setNoticeTotalCount', data.totalCount);
      });
    },
    create(context, data) {
      return api.createNotice(data);
    },
    update(context, data) {
      return api.updateNotice(data);
    },
    remove(context, id) {
      return api.removeNotice(id);
    },
    enable(context, id) {
      return api.enableNotice(id);
    },
    disable(context, id) {
      return api.disableNotice(id);
    }
  }
};

appStore.registerModule('notice', store);
